import fontsList from 'components/Templates/fontsList';

export default function getFontsMap() {
  let fontsMap = {};

  fontsList.forEach(font => {
    fontsMap[font.name.replace(/\s|-|,/g, '_').toUpperCase()] = {fontFamily: `${font.name}, ${font.fallback}`};
  })

  return fontsMap;
}
